module.exports = __webpack_public_path__ + "static/step-2-334b684ac52ae47742004bd525e501f3.png";